import Breadcrumb from "../Component/Breadcrumb";
import Footer from "../Component/Footer";
import Header from "../Component/Header";
import Menu from "../Component/Menu";
import PageTitle from "../Component/PageTitle";

const Philosophy = () => {
  const homeMenu = [
    // { label: "Awards & Achievements", link: "/awardsAcheivements" },

{
      label: "Awards & Achievements",
      link: "/awardsAcheivements",
      subMenu: [
        { label: "Accolades & Achievements", link: "/awardsAcheivements" },
        { label: "Students Achievements", link: "/studentsAcheivements" },
      ],
    },

    {
      label: "Gallery",
      link: "/Gallery",
      subMenu: [
        { label: "Photo Gallery", link: "/Gallery" },
        { label: "Video Gallery", link: "/VideoGallery" },
      ],
    },
    {
      label: "Careers",
      link: "/careers-openings",
      subMenu: [{ label: "Philosophy", link: "/philosophy" }],
    },
    { label: "School Calendar", link: "/calender" },
    {
      label: "Alumni",
      link: "",
      subMenu: [
        { label: "Admissions", link: "/admission" },
        { label: "Admissions IIT", link: "/admissionIIT" },
      ],
    },

    { label: "eMagazine", link: "/Magazine" },
    { label: "TAABIR Digital Dreams", link: "/digitaldreams" },
    {
      label: "CUET",
      link: "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/CUET.pdf",
    },
  ];
  return (
    <>
      <Header />
      <Breadcrumb breadImage="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/banner-vision.jpg" />
      <Menu MenuItem={homeMenu} />
      <div className="padding-blk inner-page">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <PageTitle
                pageTitle="Philosophy"
                breadEnd="Philosophy"
                breadMid="Philosophy"
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <p>
                We are looking for enterprising and industrious teachers who
                believe in leaving no stone unturned to accomplish pinnacles in
                the development of students. Candidates must be products of top
                rated institutions, must be proficient in their respective
                domain with prolific command on English in both written and
                verbal expression and must be adept at automation skills. Lotus
                Valley is one of the fastest growing educational institutions
                and promises great opportunities for candidates who are
                innovative, resourceful, sincere and inspiring academic prodigy.
                Selected candidates will be trained by Brown University.
              </p>
              <p>
                Salary as per 7th Pay Commission. Higher emoluments may be
                considered for deserving candidates.
              </p>
              <p>
                Apply to the Principal, on prescribed application forms
                available on our website.
              </p>
              <p>
                Management reserves the right to call only short-listed
                candidates for interview.
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default Philosophy;
